import { EboObject } from '../base-classes/ebo-object';
import { Hub } from '../places/hub/hub';
import { TenantCredential } from './tenant-credential';

export class CredentialHub extends EboObject {
  hubID: number;
  hub: Hub;
  credentialID: string;
  credential: TenantCredential;

  constructor(jsonData: Partial<CredentialHub>) {
    super(jsonData);
    if (jsonData.hub) this.hub = new Hub(jsonData.hub);
    if (jsonData.credential) this.credential = new TenantCredential(jsonData.credential);
  }
}
